import React from "react";

import { ContextualConversationLoader, ConversationsPage } from "@/components/features";
import { fakeI18n } from "@/i18n";
import { AppRoute, RouteItem } from "@/shared/domain";
import { Scope } from "@/shared/hooks/useAuth/types";

export const conversationsRoutes = (): RouteItem[] => {
    return [
        {
            path: AppRoute.Conversations,
            element: <ConversationsPage />,
            breadcrumb: fakeI18n.t("Breadcrumbs.Conversations"),
            denyScopes: [Scope.Preview],
        },
        { path: AppRoute.ConversationDetail, element: <ConversationsPage />, denyScopes: [Scope.Preview] },
        {
            path: AppRoute.ConversationContextual,
            element: <ContextualConversationLoader />,
            denyScopes: [Scope.Preview],
        },
    ];
};
